import { Outlet, useLocation } from 'react-router-dom'
import NewNavbar from '../components/common/Navbar/NewNavbar'
import FooterForLab from '../components/common/Footer/Footer-For-Lab'

const MainLayout = () => {
  const location = useLocation()

  // Function to check if navigation should be hidden
  const shouldHideNavigation = () => {
    const pathname = location.pathname

    // Exact matches
    if (
      pathname === '/login' ||
      pathname === '/regular/lab-loading' ||
      pathname === '/subscription/lab-loading' ||
      pathname === '/hackathon'
    ) {
      return true
    }

    // Pattern match for playground route: /launch/playground/:labGroupID/:moduleID/:labID
    if (pathname.startsWith('/launch/playground/')) {
      return true
    }

    return false
  }

  const hideNavigation = shouldHideNavigation()

  return (
    <main className="min-h-screen flex justify-between flex-col bg-[#F4F4F7]">
      <>
        {!hideNavigation && <NewNavbar />}
        <section className={hideNavigation ? '' : 'mt-16 h-full '}>
          <Outlet />
        </section>
      </>
      {!hideNavigation && <FooterForLab />}
    </main>
  )
}

export default MainLayout
